// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo-module_Logo_2QUR4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.module.css
// module id = 91
// module chunks = 5